import { css } from '@emotion/css';

export const styles = {
  benefitIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    margin-inline: auto;
    border-radius: var(--border-radius-rounded);
    background-color: var(--color-background-warning-weak);
    color: var(--color-icon-default);

    svg {
      width: 24px;
      height: 24px;
    }
  `,
};

export default styles;
